<template>
  <div class="col-md-6 col-12 project-list">
    <div class="card">
      <div class="row">
        <div class="col-md-6 d-flex">
          <ul
            class="nav nav-tabs border-tab"
            id="top-tab"
            role="tablist"
            v-for="(item, index) in tab"
            :key="index"
          >
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: item.active }"
                id="top-home-tab"
                data-bs-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="top-home"
                :aria-selected="item.active ? 'true' : 'false'"
                @click.prevent="active(item)"
                >{{ item.name }}</a
              >
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-0 me-0"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 col-12 project-list">
    <div class="card">
      <div class="row">
        <p class="text-center nav nav-link active show col-md-4 col-12 fw-bold">
          Pendientes
        </p>
        <div class="traffic-light col-md-8 col-12">
          <div class="light red" title="Mayor a 10 días">
            {{ pendientes.rojo }}
          </div>
          <div class="light yellow" title="Entre 5 y 10 días">
            {{ pendientes.amarillo }}
          </div>
          <div class="light green" title="Entre 0 y 4 días">
            {{ pendientes.verde }}
          </div>
          <div class="light blue" title="Sin recepcionar">
            {{ pendientes.azul }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12">
    <div class="card">
      <div class="card-body">
        <div class="tab-content" id="top-tabContent">
          <div
            class="tab-pane fade"
            :class="{ 'active show': item.active }"
            :id="item.id"
            role="tabpanel"
            :aria-labelledby="item.label"
            v-for="(item, index) in tab"
            :key="index"
          >
            <component
              :is="item.type"
              @traffic-light-update="handleTrafficLightUpdate"
            ></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RequestPage from "./RequestPage.vue";
export default {
  name: "topMenu",
  components: {
    RequestPage,
  },
  emits: ["traffic-light-update"],
  data() {
    return {
      tab: [
        {
          type: "RequestPage",
          name: "Solicitudes",
          active: true,
          icon: "target",
          id: "top-home",
          id1: "top-tabContent",
          label: "top-home-tab",
        },
      ],
      localTrafficLight: { rojo: 0, amarillo: 0, verde: 0, azul: 0 },
    };
  },
  computed: {
    pendientes() {
      return this.localTrafficLight;
    },
  },
  methods: {
    active(item) {
      if (!item.active) {
        this.tab.forEach((a) => {
          a.active = false;
        });
      }
      item.active = !item.active;
    },
    handleTrafficLightUpdate(data) {
      //console.log('Datos recibidos en TopMenu:', data);
      this.localTrafficLight = { ...data };
    },
  },
};
</script>
<style scoped>
.traffic-light {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background-color: #ffffff;
  border-radius: 8px;
}

.light {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  font-weight: bold;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  box-shadow: 0 0 0px rgba(0, 0, 0, 0.5);
}

.red {
  background-color: #e74c3c;
  color: #fff;
}

.yellow {
  background-color: #f1c40f;
  color: #fff;
}

.green {
  background-color: #2ecc71;
  color: #fff;
}

.blue {
  background-color: #3498db;
  color: #fff;
}
</style>
